import ForgetPWPage from "./ForgetPWPage";

export default ForgetPWPage